var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"div-badge",on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.label)?_c('label',[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_vm._v(" "),_c('span',{class:"badge color-" + _vm.color + (_vm.borderColor ? " badge-border border-color-" + _vm.borderColor : ""),domProps:{"innerHTML":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }